<template>
	<div v-if="show" class="pass-container">
		<div class="content">
			<div class="content-item content-item-right">
				<!-- <span class="close">
				 <a-icon type="close" />
				</span>-->
				<div class="right-header">
					<img :src="envTextLogo" alt/>
					<span class="login-title">登录账户</span>
				</div>
				<div class="right-content right-content-tabs">
					<div class="right-content-tab">
						<div class="right-phone">
							<input type="text" v-model="phoneName" placeholder="请输入手机号" 
							@keyup="test2()" 
							@focus="focus('phoneName')" 
							@blur="test()"/>
						</div>
						<div class="help-line help-phone" v-if="isSubmit && phoneName == ''">
							<span>手机号不能为空</span>
						</div>
						<div class="help-line help-phone" v-else v-show="isphoneErr">
							<span>手机格式错误</span>
						</div>
						<div class="right-password">
							<input type="text" v-model="codeWord" placeholder="请输入验证码"/>
							<span class="login-code">
								<span
										v-show="sendAuthCode"
										class="auth_text auth_text_blue"
										@click="getAuthCode"
								>获取验证码</span>
							<span v-show="!sendAuthCode" class="auth_text">
							<span class="auth_text_blue">{{auth_time}}</span> 秒之重新发送验证码
							</span>
						</span>
						</div>
						
						<div class="right-line"></div>
						<div class="help-line help-password" v-if="isSubmit && codeWord == ''">
							<span>验证码不能为空</span>
						</div>
						<div class="help-line help-password">
							<span v-show="iscodeErr">验证码错误</span>
						</div>
						<div class="right-phone">
							<input
									type="password"
									v-model="passWord"
									placeholder="请输入8-18位新密码（大小写字母和数字组合）"
									@blur="testword()"
									@focus="focus('newPassWord')"
							/>
						</div>
						<div class="help-line help-phone" v-if="isSubmit && passWord == ''">
							<span>新密码不能为空</span>
						</div>
						<div class="help-line help-phone" v-else v-show="ispassErr">
							<span>密码格式错误</span>
						</div>
						<div class="right-phone">
							<input
									type="password"
									v-model="newPassWord"
									placeholder="请输入8-18位新密码（大小写字母和数字组合）"
									@blur="testSame()"
									@focus="focus('surePassWord')"
							/>
						</div>
						<div class="help-line help-phone" v-if="isSubmit && newPassWord == ''">
							<span>确认密码不能为空</span>
						</div>
						<div class="help-line help-phone" v-else v-show="isSameErr">
							<span>两次输入密码不一致请重新输入</span>
						</div>
					</div>
				</div>
				<div class="right-footer">
					<a-button class="primary login-btn login-in" :loading="isHttpSubmit" @click="doSuccess()">确定
					</a-button>
					<div class="login-linelist">
						<img src="@/assets/image/homeImg/or.png" alt/>
					</div>
					<div class="login-tab">
						<div class="pass-login login-btn" @click="changeLogin()">返回登录</div>
					</div>
				</div>
			</div>
			<!-- <component :is="componentName" @regist="handleRegist" class="main-content"></component> -->
		</div>
		<!-- <global-footer :copyright="copyright" /> -->
	</div>
</template>

<script>
  import {mapMutations} from "vuex";
  const logoTextUrl = require("" + process.env.VUE_APP_LOGIN_TEXT_LOGO + "")
  // import Cookies from 'js-cookie'
  // import GlobalFooter from '../common/GlobalFooter'
  // import Login from './Login'
  // import Regist from './Regist'
  // import { environment } from '@/environments/environment'
  export default {
    name: "Common",
    // components: {GlobalFooter},
    data() {
      return {
        envTextLogo: logoTextUrl,
        componentName: "Login",
        show: false,
        isPassword: 1,
        phoneName: "", //手机号
        passWord: "", // 密码
        newPassWord: "", //用户名
        codeWord: "", //验证码
        activeKey: "1",
        tType: "password",
        isEye: true,
        isSubmit: false,
        isHttpSubmit: false,
		isphoneErr: false, //手机红色
		isphoneErr2: false, //是否能获取验证码
        ispassErr: false, //密码错误
        iscodeErr: false, //验证码错误
        isSameErr: false, //验证密码是否相同
        sendAuthCode: true /*布尔值，通过v-show控制显示‘获取按钮’还是‘倒计时’ */,
        auth_time: 0 /*倒计时 计数器*/
      };
    },
    computed: {
      systemName() {
        return this.$store.state.setting.systemName;
      },
      copyright() {
        return this.$store.state.setting.copyright;
      }
    },
    created() {
      // 方便开发测试
      // if (window.location.href.indexOf('http://localhost')==-1){
      //   window.location.href = environment.LOGIN_URL;
      // }else{
      //   this.show = true
      // }
      this.show = true;
      this.enterLogin();
      this.phoneName = ""; //用户名
      this.passWord = ""; // 密码
      this.newPassWord = ""; //用户名
      this.codeWord = "";
    },
    methods: {
      handleRegist(val) {
        this.componentName = val;
      },
      changeLogin() {
        this.$router.go(-1);
      },
      changeTab() {
        this.isPassword = 0;
      },
      changePass() {
        this.isPassword = 1;
      },
      getEye() {
        this.isEye = !this.isEye;
        if (this.isEye == true) {
          this.tType = "password";
        } else {
          this.tType = "input";
        }
      },
      //验证手机号
      test(n) {
		let reg = /^1[0-9]{10}$/;
        if (
          this.phoneName == "" ||
          this.phoneName.length <= 10 ||
          !reg.test(this.phoneName)
        ) {
		  this.isphoneErr = true;
          return false;
        } else {
		  this.isphoneErr = false;
		  return true;
        }
	  },
	  //输入时验证手机号
      test2() {
        let reg = /^1[0-9]{0,10}$/;
        if (!reg.test(this.phoneName)) {
          this.isphoneErr = true;
          return false;
        } else {
          this.isphoneErr = false;
        }
	  },
	//   重新输入 issubmit reset false
	  focus(n) {
		this.isSubmit = false;
		switch(n) {
			case 'phoneName':
				this.isphoneErr = false;
				break;
			case 'newPassWord':
				this.ispassErr = false;
				break;
			case 'surePassWord':
				this.isSameErr = false;
				break;	
		}
		
      },
      testword() {
		// var patrn = /^((?=.*[0-9])(?=.*[A-Z])(?=.*[a-z]))[0-9A-Za-z]{8,18}$/;
		var patrn = /^[0-9A-Za-z]{8,18}$/;
        if (!patrn.test(this.passWord)) {
          this.ispassErr = true;
          return false;
        } else {
          this.ispassErr = false;
        }
      },
      testSame() {
        if (this.newPassWord === this.passWord) {
          this.isSameErr = false;
        } else {
          this.isSameErr = true;
        }
      },
      enterLogin() {
        var _self = this;
        document.onkeydown = function (e) {
          var key = window.event.keyCode;

          if (key == 13 || key == 100) {
            _self.doSuccess();
          }
        };
      },
      //获取验证吗
      getAuthCode: function () {
		if(!this.test('getAuthCode')) {
			this.$message.error('请输入正确的手机号');
			return;
		}  
        let _this = this;
        this.sendAuthCode = false;
        this.auth_time = 60;
        var auth_timetimer = setInterval(() => {
          this.auth_time--;
          if (this.auth_time <= 0) {
            this.sendAuthCode = true;
            clearInterval(auth_timetimer);
          }
        }, 1000);

        //获取验证码
        _this
          .$post("/info/smsMsg/open/send", {
            type: "reset",
            mobile: _this.phoneName
          })
          .then(r => {
          })
          .catch(e => {
          });
      },

      doSuccess() {
        let _this = this;
        // let password = this.$md5(this.$md5(this.form.getFieldValue('password')+this.form.getFieldValue('password')))
        this.isSubmit = true;
        if (_this.phoneName == '' || _this.codeWord == '' || _this.newPassWord == '') {
          return;
        } else if (_this.isphoneErr || _this.ispassErr || _this.iscodeErr || _this.isSameErr) {
          return;
        } else {
          this.isHttpSubmit = true;
          this.$put("/user/open/password/reset/mobile", {
            mobile: _this.phoneName,
            smsCode: _this.codeWord,
            password: _this.newPassWord
          })
            .then(r => {
              this.isHttpSubmit = false;
              let data = r.data.data;
              _this.$message.success("重置成功");
              // this.saveLoginData(data)
              setTimeout(() => {
                _this.$router.push("/login");
              }, 2000);
            })
            .catch(e => {
              this.isHttpSubmit = false;
              setTimeout(() => {
                this.loading = false;
              }, 500);
            });
        }

      },
      ...mapMutations({
        setToken: "account/setToken",
        setExpireTime: "account/setExpireTime",
        setPermissions: "account/setPermissions",
        setRoles: "account/setRoles",
        setUser: "account/setUser",
        setTheme: "setting/setTheme",
        setLayout: "setting/setLayout",
        setMultipage: "setting/setMultipage",
        fixSiderbar: "setting/fixSiderbar",
        fixHeader: "setting/fixHeader",
        setColor: "setting/setColor"
      }),
      saveLoginData(data) {
        data.user.mainBusiness = "";
        this.setToken(data.token);
        this.setExpireTime(data.exipreTime);
        this.setUser(data.user);
        this.setPermissions(data.permissions);
        this.setRoles(data.roles);
        if (data.config) {
          this.setTheme(data.config.theme);
          this.setLayout(data.config.layout);
          this.setMultipage(data.config.multiPage === "1");
          this.fixSiderbar(data.config.fixSiderbar === "1");
          this.fixHeader(data.config.fixHeader === "1");
          this.setColor(data.config.color);
        }
      }
    }
  };
</script>

<style lang="scss" scoped>
	.pass-container {
		display: flex;
		flex-direction: column;
		height: 100vh;
		overflow: auto;
		background: #fff url("../../assets/image/homeImg/bj.jpg") no-repeat center;
		background-size: cover;
		.login-linelist {
			text-align: center;
		}
		.content {
			display: block;
			width: 700px;
			margin: 133px auto 192px;
			justify-content: center;
			align-items: center;
			.content-item-right {
				width: 700px;
				height: 535px;
				border-top: 1px solid #fff;
				position: relative;
				background: linear-gradient(
								0deg,
								rgba(245, 252, 255, 1) 0%,
								rgba(255, 255, 255, 1) 100%
				);
				box-shadow: 0px 44px 88px 48px rgba(0, 0, 0, 0.6);
				.close {
					position: absolute;
					right: 20px;
					top: 20px;
				}
				.right-header {
					width: 200px;
					height: auto;
					text-align: center;
					display: flex;
					flex-direction: column;
					margin: 57px auto 45px;
					span {
						font-family: PingFangSC-Regular;
						font-size: 16px;
						font-weight: normal;
						font-stretch: normal;
						line-height: 36px;
						letter-spacing: 3px;
						color: #050505;
					}
				}
				.right-content,
				.right-footer {
					width: 367px;
					margin: 0 auto;
				}
				.login-tick {
					font-size: 14px;
					font-family: PingFang SC;
					font-weight: 300;
					color: rgba(62, 127, 255, 1);
				}
				.right-content {
					.right-password {
						margin-bottom: 20px;
					}
					.right-phone {
						margin-bottom: 20px;
						input {
							border: 0 none;
							outline: 0 none;
							background: none;
							width: 367px;
							height: 42px;
							border: 1px solid rgba(229, 233, 235, 1);
							padding: 0 10px;
						}
						input::placeholder {
							width: 72px;
							font-size: 12px;
							font-family: PingFang SC;
							font-weight: 400;
							color: rgba(195, 195, 195, 1);
							line-height: 36px;
						}
						//  border-bottom: 1px solid
					}
					.help-line {
						height: 20px;
						font-size: 12px;
						font-family: PingFang SC;
						font-weight: 400;
						color: rgba(229, 19, 19, 1);
						line-height: 20px;
						position: relative;
						margin-top: -19px;
					}
					.right-password {
						display: flex;
						justify-content: space-between;
						align-content: center;
						input {
							border: 0 none;
							outline: 0 none;
							background: none;
							-webkit-appearance: none;
							-webkit-user-select: text;
							outline-color: transparent;
							box-shadow: none;
							-webkit-tap-highlight-color: rgba(255, 0, 0, 0);
							width: 253px;
							height: 42px;
							border: 1px solid rgba(229, 233, 235, 1);
							padding: 0 10px;
							// -webkit-tap-highlight-color:rgba(0,0,0,0);
						}
						input::placeholder {
							font-size: 12px;
							font-family: PingFang SC;
							font-weight: 400;
							color: rgba(195, 195, 195, 1);
							line-height: 36px;
						}
						input.input-tick {
							width: 200px;
						}
						.login-code {
							width: 101px;
							height: 42px;
							background: rgba(55, 134, 255, 1);
							border-radius: 4px;
							text-align: center;
							line-height: 42px;
							font-size: 12px;
							font-family: PingFang SC;
							font-weight: 400;
							color: rgba(255, 255, 255, 1);
							cursor: pointer;
						}
					}
					.auto-login {
						display: flex;
						justify-content: space-between;
						align-content: center;
						span {
							height: 12px;
							font-size: 12px;
							font-family: PingFang SC;
							font-weight: 400;
							color: rgba(22, 34, 50, 1);
							line-height: 20px;
						}
					}
				}
				.right-footer {
					margin-top: 20px;
					.login-btn {
						width: 367px;
						height: 42px;
						border-radius: 4px;
						text-align: center;
						line-height: 42px;
						font-size: 14px;
						font-family: PingFang SC;
						font-weight: 400;
						color: rgba(255, 255, 255, 1);
						cursor: pointer;
					}
					.login-in {
						background: rgba(62, 127, 255, 1);
					}
					.pass-login,
					.code-login {
						border: 1px solid rgba(195, 195, 195, 1);
						font-size: 12px;
						font-family: PingFang SC;
						font-weight: 400;
						color: rgba(159, 159, 159, 1);
					}
				}
			}
		}

		// .content {
		//   padding: 32px 0;
		//   flex: 1;
		//   @media (min-width: 768px){
		//     padding: 116px 0 10px;
		//   }
		//   .main-content {
		//     width: 368px;
		//     margin: 0 auto;
		//     @media screen and (max-width: 576px) {
		//       width: 95%;
		//     }
		//     @media screen and (max-width: 320px) {
		//       .captcha-button{
		//         font-size: 14px;
		//       }
		//     }
		//   }
		// }
	}
</style>
